// MF-67 — small ⓘ help icon with a tooltip, for explaining journal fields inline.
import { Tooltip } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const HelpTip = ({ title }) =>
  title ? (
    <Tooltip arrow title={title}>
      <span
        style={{ cursor: 'help', display: 'inline-flex', alignItems: 'center', height: 16, fontSize: 13 }}
      >
        <FontAwesomeIcon icon={['fal', 'circle-info']} className='text-primary opacity-60 px-1' />
      </span>
    </Tooltip>
  ) : null

export default HelpTip
